export const getCurrentInstance = (url) => {
  let token = url.split('.')[0]
  return token
    .replace(/^https:\/\/|http:\/\//, '')
    .replace(/-menu-dev$/, '')
    .replace(/-menu-qa$/, '')
    .replace(/-menu-uat$/, '')
    .replace(/-menu$/, '')
}

export const createSpaLink = (appDomain, subdomain, instanceName) => {
  const APP_ENV = process.env.REACT_APP_APP_ENV

  const protocol = 'https://'
  const prefix = subdomain.prefix ?? ''
  const subdomainSuffix = subdomain.suffix ?? ''
  const envSuffix = ['prd', 'production'].includes(APP_ENV)
    ? ''
    : `-${APP_ENV}`
  const domain = appDomain ?? 'ordernext.com'

  return `${protocol}${prefix}${instanceName}${subdomainSuffix}${envSuffix}.${domain}`
}

export const createLegacyCanopyLink = (path = '') => {
  const ORG = process.env.REACT_APP_ORG
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const ECOSYSTEM = process.env.REACT_APP_ECOSYSTEM

  return `https://canopy.${APP_ENV}.${ECOSYSTEM}.vnops.net/${path}?url_organization_name=${ORG}`
}

export const createRevenueCenterImageLink = (
  uuids = [],
  orgName = ''
) => {
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const links =
    uuids.map((uuid) => ({
      url: `https://d2bekohrrq5iy7.cloudfront.net/${orgName}/${APP_ENV}/stands-tout-${uuid}`,
      uuid,
    })) ?? []

  return links
}

export const createMenuImageLink = (uuids = [], orgName = '') => {
  const APP_ENV = process.env.REACT_APP_APP_ENV

  const links =
    uuids.map((uuid) => ({
      url: `https://d2bekohrrq5iy7.cloudfront.net/${orgName}/${APP_ENV}/stand-menus-tout-${uuid}`,
      uuid,
    })) ?? []

  return links
}

export const createItemImageLink = (
  productSkus = [],
  orgName = ''
) => {
  const APP_ENV = process.env.REACT_APP_APP_ENV
  const prefixedItem = APP_ENV === 'prd' ? 'item' : `${APP_ENV}_item`

  const links =
    productSkus.map((productSku) => ({
      url: `https://d1hgunbs8ulpw7.cloudfront.net/${orgName}/${prefixedItem}/${productSku}`,
      uuid: productSku,
    })) ?? []

  return links
}
